import { Box, Checkbox, Radio, FormControlLabel, RadioGroup, FormLabel, FormControl, Breadcrumbs, Button, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React, { use, useEffect, useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { currencyOptions, useCommonStyles } from '../../utils';
import CommonAutoComplete from '../Common/CommonAutoComplete';
import { getVendors, image } from '../../Redux/Actions/Vendor';
import ErrorHandler from '../../lib/errorHandler';
import CommonTextField from '../Common/CommonTextField';
import CommonDatePicker from '../Common/CommonDatePicker';
import CommonLabel from '../Common/CommonLabel';
import CommonFileUpload from '../Common/CommonFileUpload';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import dayjs from 'dayjs';
import { addPurchaseEntry, getAdvancelicenseNumber, getAllPOList, getGrnAndLotNumberByPoNumber, getLotNumbers, getRemainingQuantity, updatePurchaseEntry, getPurchaseEntryNumber } from '../../Redux/Actions/PurchaseEntry';
import { getPoDcumentsByPoNumber } from "../../Redux/Actions/PurchaseOrder"
import ErrorMessage from '../Common/ErrorMessage';
import { allowOnlyNumbers } from '../../utils/regex';
import { isCompleteDate } from '../../lib/standardDateFormat';

const AddUpdatePurchaseEntry = ({ setRemainingQuantityData, remainingQuantityData, setIsOpenAddUpdatePurchaseEntry, setData, data, selectedItem, setSelectedItem, _getPurchaseEntry, purchaseOrderList, setPurchaseOrderList, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [errors, setErrors] = useState({});

    const [vendorPage, setVendorPage] = useState(1);
    const [vendorTotalCount, setVendorTotalCount] = useState();
    const [vendorList, setVendorList] = useState([]);
    const [vendorOptions, setVendorOptions] = useState([]);
    const [searchVendor, setSearchVendor] = useState();

    const [poNumberPage, setPoNumberPage] = useState(1);
    const [poNumberTotalCount, setPoNumberTotalCount] = useState();
    const [poNumberList, setPoNumberList] = useState([]);
    const [poNumberOptions, setPoNumberOptions] = useState([]);
    const [searchPoNumber, setSearchPoNumber] = useState();

    const [lotNumberPage, setLotNumberPage] = useState(1);
    const [lotNumberTotalCount, setLotNumberTotalCount] = useState();
    const [lotNumberList, setLotNumberList] = useState([]);
    const [lotNumberOptions, setLotNumberOptions] = useState([]);
    const [searchLotNumber, setSearchLotNumber] = useState();
    const [isAdvanceLicense, setIsAdvanceLicense] = useState(!!data?.advanceLicenseId?.length);
    const [advanceLicenseNoList, setAdvanceLicenseNoList] = useState([]);
    const [selectedRows, setSelectedRows] = useState(data?.advanceLicenseItems ? data?.advanceLicenseItems : []);
    const [purchaseEntryNumber, setPurchaseEntryNumber] = useState(0);
    const [selectedOptions, setSelectedOptions] = useState([]);


    // console.log(data, "data");
    // Toggle single row
    const handleRowSelect = (row, index) => {
        const exists = selectedRows.some(item => item.id === index); // check by id
        if (exists) {
            // Remove row from selectedRows
            setSelectedRows(selectedRows.filter(item => item.id !== index));
        } else {
            // Add row with new fields initialized to 0 and unique id
            setSelectedRows([
                ...selectedRows,
                {
                    ...row,
                    index,
                    id: index, // store unique id (you can also do `${index}-${Date.now()}` for more uniqueness)
                    advanceLiceneseQuantity: null,
                    advanceLicenesePrice: null
                }
            ]);
        }
    };

    // console.log(purchaseOrderList, "purchaseOrderList")

    const handleSelectAll = () => {
        if (selectedRows.length === purchaseOrderList.length) {
            setSelectedRows([]);
        } else {
            const allRows = purchaseOrderList.map((row, index) => ({
                ...row,
                index,
                id: index, // unique id
                advanceLiceneseQuantity: 0,
                advanceLicenesePrice: 0
            }));
            setSelectedRows(allRows);
        }
    };

    // console.log(selectedRows, "selected rows")

    console.log("on change data ", data)
    useEffect(() => {
        setData({ ...data, advanceLicenseItems: selectedRows });
    }, [selectedRows])


    // console.log(data, "data");
    // ============== Handler ==============
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdatePurchaseEntry(false); setData({}); setSelectedItem({}); setPurchaseOrderList([]); setSearchValue('') }}>
            Purchase Entry
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`${selectedItem?._id ? "Edit" : "Create New"} Purchase Entry`}
        </Typography>,
    ];

    const handleChangeForItems = (row, value, name, index) => {
        const formattedValue = (typeof value === 'string' && value.includes("."))
            ? parseFloat(value).toFixed(3).replace(/\.?0+$/, "") // remove trailing zeros
            : value;
        if (name == "supplyQuantity") {
            const updateItem = purchaseOrderList?.map((ele, i) => {
                if (i == index) {
                    const supply = parseFloat(formattedValue) || 0;
                    const initial = ele?.initialRemainingQuantity || (parseFloat(ele?.remainingQuantity) || 0) + (parseFloat(ele?.supplyQuantity) || 0);
                    return {
                        ...ele,
                        supplyQuantity: formattedValue,
                        subTotal: (ele?.ratePerUnit || 0) * supply,
                        remainingQuantity: (initial - supply).toFixed(3).replace(/\.?0+$/, ""),
                        initialRemainingQuantity: initial
                    }
                } else {
                    return {
                        ...ele
                    }
                }
            })
            setPurchaseOrderList(updateItem)
        } else if (name == "ratePerUnit") {
            const updateItem = purchaseOrderList?.map((ele, i) => {
                if (i == index) {
                    const rate = parseFloat(formattedValue) || 0;
                    const supply = parseFloat(ele?.supplyQuantity) || 0;
                    return {
                        ...ele,
                        ratePerUnit: formattedValue,
                        subTotal: (rate * supply)
                    }
                } else {
                    return {
                        ...ele
                    }
                }
            })
            setPurchaseOrderList(updateItem)
        } else {
            const updateItem = purchaseOrderList?.map((ele, i) => {
                if (i == index) {
                    return {
                        ...ele,
                        [name]: formattedValue,
                    }
                } else {
                    return {
                        ...ele
                    }
                }
            })
            setPurchaseOrderList(updateItem)
        }
    }


    // console.log(purchaseOrderList, "purchaseOrderList")
    const handleChangePrice = (rowIndexInList, value) => {
        const quantity = Number(value);

        setSelectedRows(prevRows =>
            prevRows.map(row => {
                if (row.index === rowIndexInList) {
                    const ratePerUnit = Number(row.ratePerUnit || 0);

                    // Ensure quantity does not exceed remainingQuantity
                    const remainingQuantity = Number(row.remainingQuantity || 0);
                    const validQuantity = quantity > remainingQuantity ? remainingQuantity : quantity;

                    const price = validQuantity * ratePerUnit;

                    return {
                        ...row,
                        advanceLiceneseQuantity: validQuantity,
                        advanceLicenesePrice: price
                    };
                }
                return row;

            })
        );
    };

    console.log(advanceLicenseNoList)

    const _gteadvanceLicenseDetails = async () => {
        try {
            const body = {
                poNumber: data.poNumber.poNumber
            };

            const response = await dispatch(getPoDcumentsByPoNumber(body));
            const error = await ErrorHandler(response, setSnackBar);

            if (!error) return;

            const advanceLicenseData = response?.payload?.data?.response;

            if (!advanceLicenseData) return;

            if (advanceLicenseData?.advanceLicenses === false) {
                setIsAdvanceLicense(prev => prev !== false ? false : prev);
                return;
            }

            if (advanceLicenseData?._id) {
                setIsAdvanceLicense(prev => prev !== true ? true : prev);
                const data = [{
                    advanceLicenseNo: advanceLicenseData.advanceLicensesNumber,
                    _id: advanceLicenseData?._id
                }]
                setSelectedOptions(data);
                handleChange("advanceLicenseId", advanceLicenseData._id);
            }

        } catch (error) {
            console.error("Error fetching Advance License:", error);
        }
    };

    useEffect(() => {
        _gteadvanceLicenseDetails();
    }, [data?.poNumber?.poNumber]);


    const handleChange = (name, value) => {
        if (name == "vendor") {
            setData({ ...data, [name]: value, poNumber: '', })
            setPurchaseOrderList([])
            setPoNumberList([])
            setPoNumberPage(1)
        } else if (name == "poNumber") {
            setLotNumberList([])
            // const temp = value?.purchaseOrder?.map((ele) => {
            //     return {
            //         "itemName": ele?.itemName,
            //         "quantity": ele?.quantity,
            //         "unit": ele?.unit,
            //         "ratePerUnit": ele?.ratePerUnit,
            //         "supplyQuantity": 0,
            //         "remainingQuantity": ele?.remainingQuantity,
            //         "rate": 0,
            //         "subTotal": ele?.subTotal
            //     }
            // })
            // setPurchaseOrderList(temp)
            setData({ ...data, [name]: value, unitType: value?.unitType, currency: currencyOptions?.find((ele) => ele?.name == value?.moneyType), lotNumber: "", })
        } else {
            setData({ ...data, [name]: value })
        }
    }
    const handleUploadImg = async (files, fieldName) => {
        setFullPageLoader(true);
        let response;
        const formData = new FormData();
        formData.append("image", files[0]);
        response = await dispatch(image(formData));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                const imageUrl = response?.payload?.data?.[0]?.image;
                if (imageUrl) {
                    setData((prev) => ({
                        ...prev,
                        [fieldName]: imageUrl,
                    }));
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // // ============= get Remaining Quantity API =============
    const _getRemainingQuantity = async () => {
        setFullPageLoader(true);
        let response;
        let body = {
            poNumber: data?.poNumber?.poNumber,
        }
        response = await dispatch(getRemainingQuantity(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                // console.log(response?.payload?.data?.response)
                const temp = response?.payload?.data?.response?.[0]?.purchaseOrder?.map((ele) => {
                    const remainingqty = ele?.remainingQuantity 
                    return {
                        "itemName": ele?.itemName,
                        "quantity": ele?.quantity,
                        "unit": ele?.unit,
                        "ratePerUnit": ele?.ratePerUnit,
                        "supplyQuantity": 0,
                        "remainingQuantity": +remainingqty,
                        "initialRemainingQuantity": +remainingqty,
                        "rate": ele?.rate,
                        "subTotal": ele?.subTotal,
                        "id": ele.uid
                    }
                })
                // console.log(temp, "temp")
                setPurchaseOrderList(temp)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============== Get Vendor API ==============
    const _getVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : vendorPage,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        { (vendorList?.length !== vendorTotalCount) && setVendorPage(vendorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText ? searchText : "");
            setVendorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setVendorList([...vendorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        setVendorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText);
            setVendorList(response?.payload?.data?.response);
        }
    };

    // ============== Get PO Number API ==============
    const _getPoNumber = async (p, searchText) => {
        let response;
        let body = {
            "vendorName": data?.vendor?.name,
            "limit": 10,
            "page": p ? p : poNumberPage
        };
        response = await dispatch(getAllPOList(body));
        { (poNumberList?.length !== poNumberTotalCount) && setPoNumberPage(poNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPoNumber(searchText ? searchText : "");
            setPoNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setPoNumberList([...poNumberList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForPoNumber = async (p, searchText) => {
        let response;
        let body = {
            "vendorName": data?.vendor?.name,
            "limit": 10,
            "page": p
        };
        response = await dispatch(getAllPOList(body));
        setPoNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPoNumber(searchText);
            setPoNumberList(response?.payload?.data?.response);
        }
    };
    const _getAdvanceLicense = async () => {
        try {
            const response = await dispatch(getAdvancelicenseNumber());
            setAdvanceLicenseNoList(response?.payload?.data?.document);
        } catch (error) {
            console.error("Error fetching Advance License:", error);
        }
    };

    useEffect(() => {
        if (isAdvanceLicense) {
            _getAdvanceLicense();
        }
    }, [isAdvanceLicense]);
    // ============== Get Lot Number API ==============
    const _getLotNumber = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : lotNumberPage,
            "poNumber": data?.poNumber?.poNumber
        };
        response = await dispatch(getGrnAndLotNumberByPoNumber(body));
        { (lotNumberList?.length !== lotNumberTotalCount) && setLotNumberPage(lotNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchLotNumber(searchText ? searchText : "");
            setLotNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != lotNumberList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setLotNumberList([...lotNumberList, ...response?.payload?.data?.response]);
                } else {
                    setLotNumberList([])
                }
            }
        }
    };



    const handleChangeInputForLotNumber = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "poNumber": data?.poNumber?.poNumber
        };
        response = await dispatch(getGrnAndLotNumberByPoNumber(body));
        setLotNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchLotNumber(searchText);
            setLotNumberList(response?.payload?.data?.response);
        }
    };
    const validStep = () => {
        let formIsValid = true;
        let errors = {}

        if (!data?.vendor?.name) {
            formIsValid = false
            errors.vendor = "Please select vendor."
        }
        // if (!data?.poNumber?.poNumber) {
        //     formIsValid = false
        //     errors.poNumber = "Please select po number."
        // }
        if (!data?.grnNumber) {
            formIsValid = false
            errors.grnNumber = "Please enter grn number."
        }
        if (!data?.invoiceNumber) {
            formIsValid = false
            errors.invoiceNumber = "Please enter invoice number."
        }
        // if (data?.poNumber?.category != 5 && data?.poNumber?.category != 6) {
        //     if (!data?.lotNumber?.lotNumber) {
        //         formIsValid = false
        //         errors.lotNumber = "Please select lot number."
        //     }
        // }

        if (data?.invoiceDate) {
            if (!isCompleteDate(data?.invoiceDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid invoice date")
            }
        }
        if (data?.deliveryDate) {
            if (!isCompleteDate(data?.deliveryDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid delivery date")
            }
        }
        // if (purchaseOrderList?.some((ele) => ele?.supplyQuantity <= 0 || ele?.rate <= 0)) {
        //     formIsValid = false
        //     setSnackBar('error', "Please enter a valid supply quantity and rate for all items.")

        // }

        if (isAdvanceLicense == true && !data?.advanceLicenseId) {
            console.log("this is errror ")
            formIsValid = false
            errors.advanceLicenseId = "Please select Advance License."
            setSnackBar("error", "Please select advance license number")
        }
        setErrors(errors)

        return formIsValid;
    }
    // ============= add Inventory Field API =============
    const _addUpdatePurchseEntry = async () => {
        if (validStep()) {
            setFullPageLoader(true);
            let response;
            let body = {
                "vendorName": data?.vendor?.name || null,
                "poNumber": data?.poNumber?.poNumber || null,
                "invoiceNumber": data?.invoiceNumber || null,
                "GRNNUmber": data?.grnNumber || null,
                "testCertificateDocument": data?.testCertificate || null,
                "moneyType": data?.currency?.name || null,
                "invoiceDate": data.invoiceDate ? dayjs(data.invoiceDate).format("YYYY-MM-DD") : null,
                "deliveryDate": data.deliveryDate ? dayjs(data.deliveryDate).format("YYYY-MM-DD") : null,
                "otherCharges": data?.otherCharges || null,
                "purchaseOrder": purchaseOrderList || null,
                "lotNumber": data?.lotNumber?.lotNumber || null,
                "totalAmount": data?.total || null,
                "description": data?.remarks || null,
                "unitType": data?.unitType || null,
                "advanceLicenseId": data?.advanceLicenseId || null,
                "advanceLicenseItems": data?.advanceLicenseItems || [],
                "purchaseEntryNumber": data?.purchaseEntryNumber || null
            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }
            const fn = selectedItem?._id ? updatePurchaseEntry : addPurchaseEntry
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setIsOpenAddUpdatePurchaseEntry(false)
                    setData({ currency: { name: "INR", symbol: "₹" } })
                    setSelectedItem({})
                    setPurchaseOrderList([])
                    _getPurchaseEntry()
                    setSearchValue('')
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };

    const _getPurchaseEntryNumber = async () => {
        try {
            const response = await dispatch(getPurchaseEntryNumber()).unwrap();
            const number = response.data?.purchaseEntryNumber;

            setPurchaseEntryNumber(number);

            setData(prev => ({
                ...prev,
                purchaseEntryNumber: number
            }));
        } catch (error) {
            console.error("Error fetching purchase entry number", error);
        }
    };
    // console.log(data, "data")
    // ====================== Use Effects ======================
    useEffect(() => {
        const poListAllItemSubTotal = purchaseOrderList?.reduce((acc, item) => acc + (item?.subTotal || 0), 0)
        const finalTotal = (+poListAllItemSubTotal || 0) + (+data?.otherCharges || 0)
        setData({
            ...data,
            total: finalTotal
        })
    }, [data?.otherCharges, purchaseOrderList]);

    useEffect(() => {
        _getPurchaseEntryNumber()

    }, [])

    useEffect(() => {
        if (data?.poNumber?.moneyType) {
            const temp = currencyOptions?.find((ele) => ele?.name == data?.poNumber?.moneyType)
            setData({
                ...data,
                currency: temp
            })
            _getRemainingQuantity();
            _getLotNumber(1);
        }
    }, [data?.poNumber]);

    useEffect(() => {
        _getVendor();
    }, []);

    useEffect(() => {
        if (data?.vendor) {
            _getPoNumber();
        }
    }, [data?.vendor]);

    useEffect(() => {
        setVendorOptions(vendorList?.map((e) => e));
    }, [vendorList]);

    useEffect(() => {
        setPoNumberOptions(poNumberList?.map((e) => e));
    }, [poNumberList]);

    useEffect(() => {
        setLotNumberOptions(lotNumberList?.map((e) => e));
    }, [lotNumberList]);



    return (
        <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>  {`${selectedItem?._id ? "Edit" : "Create New"} Purchase Entry`}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px" }}>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}> Basic Details</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                valid
                                type="text"
                                label="Purchase Entry Number"
                                name="purchaseEntryNumber"
                                value={data?.purchaseEntryNumber || purchaseEntryNumber || null}
                                placeholder="Purchase Entry Number"
                                disabled   // 🔒 field disabled
                            />
                            {/* <ErrorMessage text={!data?.invoiceNumber ? errors.invoiceNumber : ""} /> */}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                label="Vendor"
                                placeholder="Select Vendor"
                                options={vendorOptions || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={data?.vendor || null}
                                onChange={(e, newValue) => handleChange("vendor", newValue)}
                                loadData={(vendorOptions?.length !== vendorTotalCount) ? _getVendor : undefined}
                                handleSearch={(e) => handleChangeInputForVendor(1, e?.target?.value)}
                                searchValue={searchVendor}
                                valid
                            />
                            <ErrorMessage text={!data?.vendor?.name ? errors.vendor : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label="PO Number"
                                placeholder="Select PO Number"
                                options={poNumberOptions || []}
                                getOptionLabel={(option) => option?.poNumber || ""}
                                value={data?.poNumber || null}
                                onChange={(e, newValue) => handleChange("poNumber", newValue)}
                                loadData={(poNumberOptions?.length !== poNumberTotalCount) ? _getPoNumber : undefined}
                                handleSearch={(e) => handleChangeInputForPoNumber(1, e?.target?.value)}
                                searchValue={searchPoNumber}
                            />
                            <ErrorMessage text={!data?.poNumber?.poNumber ? errors.poNumber : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                valid
                                type="text"
                                label="Invoice Number"
                                name="invoiceNumber"
                                value={data.invoiceNumber}
                                placeholder="Enter The Invoice Number"
                                onChange={(e) => handleChange("invoiceNumber", e.target.value)}
                            />
                            <ErrorMessage text={!data?.invoiceNumber ? errors.invoiceNumber : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonDatePicker
                                label="Invoice Date"
                                onChange={(value) => handleChange("invoiceDate", value)}
                                value={data?.invoiceDate || null}
                                name="invoiceDate"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="GRN number"
                                name="grnNumber"
                                value={data.grnNumber}
                                placeholder="Enter The GRN number"
                                onChange={(e) => {
                                    if (+e.target.value >= 0) {
                                        handleChange("grnNumber", e.target.value)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonDatePicker
                                label="Delivery Date"
                                onChange={(value) => handleChange("deliveryDate", value)}
                                value={data?.deliveryDate || null}
                                name="deliveryDate"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl component="fieldset">
                                <FormLabel sx={{
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    fontFamily: "Satoshi-Medium",
                                    color: "#2E2E30",
                                    marginBottom: "8px",
                                    textTransform: "capitalize",
                                }}>Advance License</FormLabel>
                                <RadioGroup
                                    row
                                    name="advanceLicense"
                                    value={isAdvanceLicense ? "yes" : "no"}
                                    onChange={(e) => setIsAdvanceLicense(e.target.value === "yes")}
                                >
                                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {
                            isAdvanceLicense && (
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonAutoComplete
                                        valid
                                        label="Advance License Number"
                                        placeholder="Select Advance License Number"
                                        options={advanceLicenseNoList || []}
                                        getOptionLabel={(option) => option?.advanceLicenseNo || ""}
                                        value={
                                            advanceLicenseNoList?.find(
                                                (item) => item._id === data?.advanceLicenseId
                                            ) || selectedOptions?.find((item) => item._id === data?.advanceLicenseId) || null
                                        }
                                        disabled={selectedItem?._id ? true : false}
                                        onChange={(e, newValue) =>
                                            handleChange("advanceLicenseId", newValue?._id || null)
                                        }
                                    />
                                    <ErrorMessage text={errors.advanceLicenseId || ""} />
                                </Grid>
                            )
                        }

                        <Grid item xs={12} >
                            <CommonLabel title={'Upload Test Certificate'} />
                            <CommonFileUpload
                                value={data.testCertificate}
                                setFieldValue={setData}
                                handleImageChange={(files) => handleUploadImg(files, "testCertificate")}
                                accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                                handleSingleDelete={() => {
                                    setData({
                                        ...data,
                                        testCertificate: "",
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CommonLabel title={'Purchase Order'} />
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <StyledTableRow isHeader isBordered style={{ backgroundColor: "#E9E9E9" }}>
                                                {isAdvanceLicense && <StyledTableCell align='center'>
                                                    <Checkbox
                                                        checked={selectedRows.length === purchaseOrderList.length && purchaseOrderList.length > 0} // only true if all selected
                                                        indeterminate={selectedRows.length > 0 && selectedRows.length < purchaseOrderList.length} // true if some selected
                                                        onChange={handleSelectAll}
                                                    />
                                                </StyledTableCell>}
                                                <StyledTableCell align='center'>Item(s)</StyledTableCell>
                                                <StyledTableCell align='center'>Quantity</StyledTableCell>
                                                <StyledTableCell align='center'>Unit</StyledTableCell>
                                                <StyledTableCell>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        {"Rate per Unit"}
                                                        <CommonAutoComplete
                                                            width={"60px"}
                                                            clearIcon={false}
                                                            placeholder="Select Currency"
                                                            options={currencyOptions || []}
                                                            getOptionLabel={(option) => option?.name || ""}
                                                            value={data?.currency || null}
                                                            onChange={(e, newValue) => setData({ ...data, currency: newValue })}
                                                            optionsMargin={0.8}
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": { py: "4px !important", borderRadius: "30px" },
                                                                "& .MuiAutocomplete-endAdornment": { right: "0px !important" }
                                                            }}
                                                        />
                                                    </Box>
                                                </StyledTableCell>
                                                <StyledTableCell align='center'>Supply Quantity</StyledTableCell>
                                                <StyledTableCell align='center'>Remain Quantity</StyledTableCell>
                                                <StyledTableCell align='center'>Amount</StyledTableCell>
                                                <StyledTableCell align='center'>Rate</StyledTableCell>
                                                {isAdvanceLicense && <StyledTableCell align='center'>Advance Licenese Quantity</StyledTableCell>}
                                                {isAdvanceLicense && <StyledTableCell align='center'>Advance Licenese Price</StyledTableCell>}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {purchaseOrderList?.length > 0 ?
                                                purchaseOrderList?.map((row, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <StyledTableRow noColor isBordered>
                                                                {isAdvanceLicense && <StyledTableCell isBordered>
                                                                    <Checkbox
                                                                        checked={selectedRows.some(item => item.index === index)} // checked if this row is selected
                                                                        onChange={() => handleRowSelect(row, index)}
                                                                    />
                                                                </StyledTableCell>}
                                                                <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "11px 10px", width: "fit-content", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'} noWrap>{row?.itemName ? row?.itemName : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "11px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.quantity ? row?.quantity : "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered >
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "11px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.unit ? row?.unit : data?.unitType ?? "NA"}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    <CommonTextField
                                                                        width={"80px"}
                                                                        type="number"
                                                                        name="ratePerUnit"
                                                                        value={row?.ratePerUnit}
                                                                        placeholder="Ex. 10"
                                                                        isCurrency
                                                                        currencyValue={data?.currency?.symbol}
                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        onChange={(e) => {
                                                                            if (+e?.target?.value >= 0) {
                                                                                handleChangeForItems(row, e.target.value, "ratePerUnit", index)
                                                                            } else {
                                                                                return;
                                                                            }
                                                                        }}
                                                                        onKeyDown={allowOnlyNumbers}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    <CommonTextField
                                                                        width={"80px"}
                                                                        type="number"
                                                                        name="supplyQuantity"
                                                                        value={row?.supplyQuantity}
                                                                        placeholder="Ex. 10"
                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        onChange={(e) => {
                                                                            const initial = row?.initialRemainingQuantity || (parseFloat(row?.remainingQuantity) || 0) + (parseFloat(row?.supplyQuantity) || 0);
                                                                            if (+e?.target?.value <= initial && +e?.target?.value >= 0) {
                                                                                handleChangeForItems(row, e.target.value, "supplyQuantity", index)
                                                                            } else {
                                                                                return;
                                                                            }
                                                                        }}
                                                                        onKeyDown={allowOnlyNumbers}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    <CommonTextField
                                                                        width={"80px"}
                                                                        type="number"
                                                                        disabled
                                                                        name="remainingQuantity"
                                                                        value={row?.remainingQuantity}
                                                                        placeholder="Ex. 10"
                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        onChange={(e) => {
                                                                            if (+e?.target?.value >= 0) {
                                                                                handleChangeForItems(row, e.target.value, "remainingQuantity", index)
                                                                            } else {
                                                                                return;
                                                                            }
                                                                        }}
                                                                        onKeyDown={allowOnlyNumbers}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    <CommonTextField
                                                                        width={"80px"}
                                                                        type="number"
                                                                        disabled
                                                                        name="subTotal"
                                                                        value={row?.subTotal}
                                                                        isCurrency
                                                                        currencyValue={data?.currency?.symbol}
                                                                        placeholder="Ex. 10"
                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        onChange={(e) => {
                                                                            if (+e?.target?.value >= 0) {
                                                                                handleChangeForItems(row, e.target.value, "subTotal", index)
                                                                            } else {
                                                                                return;
                                                                            }
                                                                        }}
                                                                        onKeyDown={allowOnlyNumbers}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell isBordered align='center'>
                                                                    <CommonTextField
                                                                        width={"80px"}
                                                                        type="number"
                                                                        name="rate"
                                                                        value={row?.rate}
                                                                        placeholder="Ex. 10"
                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        onChange={(e) => {
                                                                            if (+e?.target?.value >= 0) {
                                                                                handleChangeForItems(row, e.target.value, "rate", index)
                                                                            } else {
                                                                                return;
                                                                            }
                                                                        }}
                                                                        onKeyDown={allowOnlyNumbers}
                                                                    />
                                                                </StyledTableCell>
                                                                {isAdvanceLicense && (
                                                                    <StyledTableCell isBordered align='center'>
                                                                        <CommonTextField
                                                                            width="80px"
                                                                            type="number"
                                                                            name="advanceLiceneseQuantity"
                                                                            placeholder="Ex. 10"
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                            value={
                                                                                (() => {
                                                                                    const rowData = selectedRows.find(item => item.index === index);
                                                                                    if (!rowData) return "";
                                                                                    const remainingQuantity = purchaseOrderList[index]?.remainingQuantity || null;
                                                                                    return rowData.advanceLiceneseQuantity > remainingQuantity
                                                                                        ? remainingQuantity
                                                                                        : rowData.advanceLiceneseQuantity;
                                                                                })()
                                                                            }
                                                                            onChange={(e) => {
                                                                                const data = purchaseOrderList.find((i) => i.id == row.id);
                                                                                console.log(data);

                                                                                let enteredValue = +e?.target?.value;

                                                                                // if entered value > supplyQuantity, use supplyQuantity instead
                                                                                if (enteredValue > row?.supplyQuantity) {
                                                                                    enteredValue = row?.supplyQuantity;
                                                                                }

                                                                                // if entered value < 0, clamp it to 0
                                                                                if (enteredValue < 0) {
                                                                                    enteredValue = 0;
                                                                                }

                                                                                handleChangePrice(index, enteredValue);
                                                                            }}

                                                                            onKeyDown={allowOnlyNumbers}
                                                                            disabled={!selectedRows.some(item => item.index === index)}
                                                                        />
                                                                    </StyledTableCell>
                                                                )}

                                                                {isAdvanceLicense && (() => {
                                                                    const selectedRow = selectedRows.find(item => item.index === index);
                                                                    const advanceLicenesePrice = selectedRow?.advanceLicenesePrice || 0;
                                                                    return (
                                                                        <StyledTableCell isBordered align='center'>
                                                                            <CommonTextField
                                                                                width="80px"
                                                                                type="number"
                                                                                disabled
                                                                                name="subTotal"
                                                                                value={advanceLicenesePrice}
                                                                                isCurrency
                                                                                currencyValue={data?.currency?.symbol}
                                                                                placeholder="Ex. 10"
                                                                                sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                                onKeyDown={allowOnlyNumbers}
                                                                            />
                                                                        </StyledTableCell>
                                                                    );
                                                                })()}

                                                            </StyledTableRow>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                // valid
                                disabled={data?.poNumber?.category == 5 || data?.poNumber?.category == 6}
                                label="Lot Number"
                                placeholder="Select Lot Number"
                                options={lotNumberOptions || []}
                                getOptionLabel={(option) => option?.lotNumber || ""}
                                value={data?.lotNumber || null}
                                onChange={(e, newValue) => handleChange("lotNumber", newValue)}
                                loadData={(lotNumberOptions?.length !== lotNumberTotalCount) ? _getLotNumber : undefined}
                                handleSearch={(e) => handleChangeInputForLotNumber(1, e?.target?.value)}
                                searchValue={searchLotNumber}
                            />
                            {/* <ErrorMessage text={(data?.poNumber?.category !== 5 && data?.poNumber?.category !== 6 && !data?.lotNumber?.lotNumber) ? errors.lotNumber : ""} /> */}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="Other Charges"
                                name="otherCharges"
                                value={data.otherCharges}
                                placeholder="Enter The Other Charges"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("otherCharges", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                                onKeyDown={allowOnlyNumbers}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                disabled={true}
                                label="Total"
                                name="total"
                                value={data.total}
                                placeholder="Enter The Total"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("total", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <CommonTextField
                                type="text"
                                multiline
                                rows={4}
                                label="Remarks"
                                name="remarks"
                                value={data?.remarks}
                                placeholder="Add Any Additional Comments/Remarks....."
                                onChange={(e) => handleChange("remarks", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} display={"flex"} gap={2} mt={1}>
                            <Button className={classes.cancelButton} onClick={() => { setIsOpenAddUpdatePurchaseEntry(false); setData({}); setSelectedItem({}); setPurchaseOrderList([]) }}>Cancel</Button>
                            <Button className={classes.saveButton} onClick={() => _addUpdatePurchseEntry()} >{selectedItem?._id ? "Update" : "Save"}</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid >
        </Grid >
    )
}

export default AddUpdatePurchaseEntry